module.exports = __webpack_public_path__ + "img/img14.819f84ae.svg";